import { Stack } from '@mui/material'

import { Typo } from '~/core/components/alias'

export const ContractInfo = (props: { fields: { label: string; value: string }[] }) => (
  <Stack spacing={2}>
    {props.fields.map(({ label, value }) => (
      <Typo key={label}>
        {label}：
        <Typo component="span" color="text.secondary">
          {value}
        </Typo>
      </Typo>
    ))}
  </Stack>
)
